import React, { useEffect, useMemo, useRef, useState } from 'react';
import OutlinedButton from '../Buttons/OutlinedButton';
import PrimaryButton from '../Buttons/PrimaryButton';
import Input from '../DataEntry/Input';
import Modal from '../Modals/Modal';
import { useDevice } from '../../Api/newSockets.api';
import { ReactComponent as RotateRightIcon } from "../../assets/icons/rotate_right.svg";

type Props = {
    source: string
    deviceId: any
    setCalibrationActive: any
}

const screens = [
    {
        order: 0,
        title: "Chessboard calibration",
        subtitle: "1. Rotacija",
        description: "Rotirajte sliku dok se kordinatne osi na slici ne podudaraju s kordinatnim osima robota."
    },
    {
        order: 1,
        title: "Chessboard calibration",
        subtitle: "2. Kordinate ishodišta",
        description: "Unesite veličinu (mm) taga od centra Delta robota pritom pazeći na predznak osi"
    }
];

const ChessboardCalibrate = (props: Props) => {

    const [modalOpen, setModalOpen] = useState(false);

    const [ux, setUx] = useState("0");
    const [uy, setUy] = useState("0");

    const [width, setWidth] = useState(960);
    const [height, setHeight] = useState(616);

    const [currentScreen, setCurrentScreen] = useState(screens[0]);

    const { rotateStream, cameraCalibrate, cancelCalibration } = useDevice();

    const imageRef = useRef(null)

    const videoElement = useMemo(() => {
        const element = new window.Image()
        element.src = props.source
        element.onload = () => {
            const width = element.width;
            const height = element.height;
            setWidth(width)
            setHeight(height)
        };
        return element
    }, [props.source])

    useEffect(() => {
        const onload = function () {
            imageRef.current = videoElement
        }
        videoElement.addEventListener('load', onload)
        return () => {
            videoElement.removeEventListener('load', onload)
        }
    }, [videoElement])

    const rotateImage = (rotation) => {
        const temp = height;
        setHeight(width);
        setWidth(temp);
        rotateStream(props.deviceId, rotation);
    };

    const calibrate = (deviceId, ux, uy, savePosition) => {
        console.log(ux)
        console.log(uy)
        cameraCalibrate(deviceId, ux, uy, savePosition)
    };

    const onClose = () => {
        setModalOpen(false);
    };

    const savePosition = (e) => {
        calibrate(props.deviceId, parseInt(ux), parseInt(uy), true)
        props.setCalibrationActive(false);
    }

    // Closing without saving: stop the calibration model and restore the assigned model.
    const handleCancel = () => {
        cancelCalibration(props.deviceId)
        props.setCalibrationActive(false);
    }

    var footer = <>
        {currentScreen.order == 1 && <OutlinedButton onClick={() => setCurrentScreen(screens[0])}>
            Back
        </OutlinedButton>}
        {currentScreen.order == 0 ? <PrimaryButton onSubmit={() => setCurrentScreen(screens[1])}>
            Next
        </PrimaryButton> :
            <PrimaryButton onSubmit={savePosition}>
                Save
            </PrimaryButton>
        }

    </>

    var header = <>
        {currentScreen.order == 1 && <div>
            <Input
                placeholder="X position"
                value={ux.toString()}
                onChange={(event) => setUx(event.target.value)}
            />
            <Input
                placeholder="Y position"
                value={uy.toString()}
                onChange={(event) => setUy(event.target.value)}
            />
        </div>}
        {currentScreen.order == 0 && <div className="rotate-button-container">
            <button onClick={() => rotateImage("clockwise")} className="rotate-button" >
                <RotateRightIcon className="arrow-icon" style={{ width: '2rem', height: '2rem' }} />
            </button>
        </div>
        }
    </>

    return (
        <div className="calibration">
            <Modal title={currentScreen.title} subtitle={currentScreen.subtitle} desc={currentScreen.description} visible={true} footer={footer} header={header} onClose={handleCancel}>
                <img src={props.source} style={{ width: width, height: height }} />
            </Modal>
        </div>
    )
};

export default ChessboardCalibrate;